import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/apartment_classification.png")